export class TallyReceiptHdr {
    accountsheaderId?: number
    accountsdetailsId?: number
    finyearmstId?: number
    txncategoryId?: number
    txncategory?: string
    purposeId?: number
    purpose?: string
    bookNumber?: number
    username?: string
    userId?: number
    receiptLocked?: boolean
  
    constructor(init?: Partial<TallyReceiptHdr>) {
      if (init) {
        Object.assign(this, init);
      }
    }
}

export class TallyReceiptDetails {
    txndate?: string
    amount?: number
    modeOfPayment?: string
    modeTranId?: string
    modeBankName?: string
    mapexternal?: boolean
    status?: boolean
  
    constructor(init?: Partial<TallyReceiptDetails>) {
      if (init) {
        Object.assign(this, init);
      }
    }
}

export class TallyNarrationDetails {
    modeDescription: string = "OFFLINE"
    receiptNbr?: number
    salutation?: string
    firstName?: string
    middleName?: string
    lastName?: string
    address?: string
    city?: string
    pinCd?: number
    mobileNbr?: string
    email?: string
    panCrdNbr?: string
    aadharCrdNbr?: string
    notes?: string
    collectedBy?: string
  
    constructor(init?: Partial<TallyNarrationDetails>) {
      if (init) {
        Object.assign(this, init);
      }
    }
}

export class CategoryPurposeModel {
  txncategorypurposeId?: number
  prefix?: string
  mode?: string
  txncategoryId?: number
  txncategory?: string
  purposeId?: number
  purpose?: string
  appcategoryId?: number
  appcategory?: string

  constructor(init?: Partial<CategoryPurposeModel>) {
    if (init) {
      Object.assign(this, init);
    }
  }
}